module.exports = __webpack_public_path__ + "img/bg_age_2.ba60ae54.png";